import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { GrupoSistemaDTO, EtapaGrupoPermisoDTO, EtapaGrupoPermisoItemDTO, GrupoEtapaPermisoDTO, GrupoEtapaPermisoItemDTO } from './types'

const getEndpoint = (url = '') => `workflow${url}`

export const HttpEtapaGrupoPermiso = {
    getGruposPorSistema: (codSistema: number): Promise<GrupoSistemaDTO[]> =>
        HttpAxiosRequest.get(getEndpoint(`/${codSistema}/grupos`)),

    getEtapaPermisos: (codSistema: number, idGrupo: number): Promise<EtapaGrupoPermisoDTO[]> =>
        HttpAxiosRequest.get(getEndpoint(`/${codSistema}/grupos/${idGrupo}/etapa-permisos`)),

    updateEtapaPermisos: (codSistema: number, idGrupo: number, permisos: EtapaGrupoPermisoItemDTO[]): Promise<any> =>
        HttpAxiosRequest.post(getEndpoint(`/${codSistema}/grupos/${idGrupo}/etapa-permisos`), permisos),

    getGrupoPermisosPorEtapa: (codSistema: number, idEtapa: number, codPais: number): Promise<GrupoEtapaPermisoDTO[]> =>
        HttpAxiosRequest.getWithQueryParamsSerializer(getEndpoint(`/${codSistema}/etapas/${idEtapa}/grupo-permisos`), { sinCodPais: codPais }),

    updateGrupoPermisos: (codSistema: number, idEtapa: number, permisos: GrupoEtapaPermisoItemDTO[]): Promise<any> =>
        HttpAxiosRequest.post(getEndpoint(`/${codSistema}/etapas/${idEtapa}/grupo-permisos`), permisos)
}
